import React from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!isLoggedIn) {
    // Back here after signing in (a link from an email or a WhatsApp, e.g. a factura's preview).
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return (
      <div className="container text-center mt-5">
        <div className="card p-4 shadow-sm" style={{ maxWidth: '500px', margin: 'auto' }}>
          <h2 className="mb-3 text-danger">Acceso no autorizado</h2>
          <p>No tienes permiso para acceder a esta sección.</p>
          <button
            className="btn w-100"
            style={{
              background: 'linear-gradient(to right, var(--mm-brand), #B01420)',
              color: '#fff',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 0',
              marginTop: '20px',
            }}
            onClick={() => navigate(-1)}
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;
